<template>
  <div class="splash splash-bg">
    <div class="splash-wrapper">
      <div class="splash-logo">
        <img src="../assets/img/logo.png"/>
      </div>
      <div class="hash">
        <h2>#SAVETOGETHER</h2>
      </div>
      <div class="loading">
        <img src="../assets/img/loading.gif"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Splash',
  mounted () {
    setTimeout(() => {
      if (this.$route.path === '/') {
        this.$router.push('/intro')
      }
    }, 5000)
  }
}
</script>

<style scoped>
  .splash-bg {
    width: 100%;
    height: 100%;
    background-image: url("../assets/img/bgsplash.jpg");
    background-size: cover;
    background-position: center;
  }

  .splash-wrapper {
    background-color: rgba(50, 50, 50, 0.8);
    text-align: center;
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .splash-logo {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }

  .splash-logo img {
    max-width: 90%;
    max-height: 15vh;
  }

  .hash {
    width: 100%;
    height: 10vh;
  }

  .hash h2 {
    font-size: 3vh;
    font-family: "Geograph-Medium";
  }

  .loading {
    width: 100%;
    height: 10vh;
  }

  .loading img {
    height: 5vh;
  }
</style>
